import React from 'react';

import { Route, Routes } from 'react-router-dom';

import { HttpError, HasNotCompaniesError, ForbiddenError, ErrorEndpoint } from '@homesusa/core';
import { PrivateRoute } from './private-route.component';

export function ErrorRoutes(): JSX.Element {
  return (
    <Routes>
      <Route element={<HttpError />} path={ErrorEndpoint.HttpError} />
      <Route element={<HasNotCompaniesError />} path={ErrorEndpoint.HasNotCompaniesError} />
      <Route path={ErrorEndpoint.ForbiddenError} element={<PrivateRoute />}>
        <Route index element={<ForbiddenError />} />
      </Route>
    </Routes>
  );
}
